import createPlugin from './createPlugin'

import MenuItemsRenderer from './Renderer/MenuItemsRenderer'

const menuItemsPlugin = settings =>
    createPlugin({
        Renderer: MenuItemsRenderer,
        ...settings,
    })

const menuItems = menuItemsPlugin()
export default menuItems

export { menuItemsPlugin, MenuItemsRenderer }
